import CobrandHeader from './CobrandHeader';

export default CobrandHeader;
